import {
	PropsWithChildren,
	useCallback,
	Children,
	cloneElement,
	ReactElement,
	ReactNode,
	useContext
} from 'react';
import { PagedDialogContext } from './Context';

type TPageItemProps = {
	id: number;
	pagesRef?: HTMLDivElement;
}

export const Page = (props: PropsWithChildren<TPageItemProps>) => {
	const { id, pagesRef, children } = props;
	const context = useContext(PagedDialogContext);
	const getItems = useCallback(() => {
		const pageItems: (ReactElement | ReactNode)[] = [];
		Children.toArray(children).forEach((Child, i) => {
			if (typeof (Child as ReactElement<any>).type === 'function') {
				pageItems.push(cloneElement((Child as ReactElement<any>), {
					context,
					pagesRef,
					key: i
				}));
			} else {
				pageItems.push(Child);
			}
		});
		return pageItems;
	}, [context, children, pagesRef]);
	return (
		<>{context && context.activeMenu === id && getItems()}</>
	)
}
Page.displayName = 'Page';
